module.exports = __webpack_public_path__ + "static/appstore-f4fb2b9c4d69576b5c0f8b559b0879aa.png";